import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=cabee118"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
import style0 from "./Mail.vue?vue&type=style&index=0&id=cabee118&prod&lang=scss"
import style1 from "./Mail.vue?vue&type=style&index=1&id=cabee118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports